export enum Status {
  NOT_APPLY,
  APPLIED,
  PASS_1ST,
  FIX_2ND,
  ADDITIONAL_QUESTION,
  ANNOUNCE,
  FAIL_1ST = 99,
}
